<template>
  <BannerBlock titleClass="" bannerCol="col-12 col-sm-9">
    <!-- <template v-slot:title>{{$t("banner.ecomSolid.title")}}</template> -->
    <template v-slot:message>
      <span class="d-block mb-1">{{$t("banner.ecomSolid.desc1", {name: shopInfo.firstName + " " +shopInfo.lastName })}}</span>
      <span class="d-block mb-1">{{$t("banner.ecomSolid.desc2")}}</span>
      <span class="d-block" v-html="$t('banner.ecomSolid.desc3')"></span>
    </template>
    <template v-slot:default>
      <img class="ml-auto align-self-end" :src="publicPath + require('@/core/assets/Dashboard/Banner/ecomsolid.png')" />
      <img class="pos-a top-left-rotate" :src="publicPath + require('@/core/assets/Dashboard/Banner/ecom-tl.svg')" />
      <!-- <div class="bg"></div> -->
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../BannerBlock";
import { mapState } from 'vuex';
export default {
  name: "EcomSolidAds",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo,
    })
  }
};
</script>
<style lang="scss" scoped>
.bg {
  background-image: url(~@/core/assets/Dashboard/Banner/ecomsolid.png);
  width: 288px;
}
.top-left-rotate {
  top: -40px;
  left: -40px;
  user-select: none;
  -webkit-user-drag: none;
}
.banner-block::v-deep {
  position: relative;
  overflow: hidden;
}
</style>
